import { AppThunk } from "@app/redux/store/root";
import { getNotifications, viewNotification } from "../../services/notifications";
import { RETRIEVE_NOTIFICATIONS, VIEW_NOTIFICATION } from "./types";

export const retriveNotifications =
    (data: any): AppThunk =>
    async (dispatch): Promise<any> => {
        try {
            const response = await getNotifications(data);
            dispatch({
                type: RETRIEVE_NOTIFICATIONS,
                payload: response.data,
            });
            return Promise.resolve(response.data);
        } catch (err: any) {
            console.log("error in notification");
            return Promise.reject(err);
        } finally {
            console.log("finally");
        }
    };

export const seeNotification =
    (ids: any, read: boolean): AppThunk =>
    async (dispatch): Promise<any> => {
        try {
            const response = await viewNotification(ids, read);

            dispatch({
                type: VIEW_NOTIFICATION,
                payload: response.data,
            });

            return Promise.resolve(response.data);
        } catch (err: any) {
            console.log("error in notification");
            return Promise.reject(err);
        } finally {
            console.log("finally");
        }
    };
